import React from "react";
import { Form, ModalBuilder } from "@redriver/cinnamon";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { renameSheet } from "features/Sheets/ManageSheet";
import { useTranslation } from "react-i18next";
import { PermissionCheck } from "features/../../../shared/components/auth";
import { Targets, Actions } from "constants/permissions";
import { DropdownItem } from "semantic-ui-react";
import { NonPropagatingInput } from "features/../../../shared/components/forms/NonPropagatingField";

const RenameSheet = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements");
  let { sheetId, sheetName } = sheet;

  return (
    <PermissionCheck action={Actions.Edit} target={Targets.Sheet}>
      <ModalBuilder
        withForm
        initialData={{ newName: sheetName }}
        submitAction={renameSheet}
        submitParams={{ sheetId }}
        onSubmitted={onSubmitted}
        renderError={false}
        renderSubmitting={false}
        renderTrigger={(trigger) => (
          <DropdownItem onClick={trigger}>
            {t("SheetActions.Rename.TriggerText")}
          </DropdownItem>
        )}
        renderModal={(modalProps, formProps) => (
          <TranslatedModal.Edit
            {...modalProps}
            header={t("SheetActions.Rename.HeaderText")}
          >
            <Form {...formProps}>
              <div className="flex">
                <NonPropagatingInput
                  field="newName"
                  label={t("SheetActions.Rename.New_name")}
                  width={25}
                />
              </div>
            </Form>
          </TranslatedModal.Edit>
        )}
      />
    </PermissionCheck>
  );
};

export default RenameSheet;
